import { Box, Button, Grid, Grid2, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import TravelGroup from "./TravelGroup";
import FromDateComponent from "./FromDateComponent";
import ToDateComponent from "./ToDateComponent";
import { useNavigate } from "react-router-dom";
import  Category  from "./Category";
dayjs?.extend(customParseFormat); // Extend for custom date format parsing

const Widget = ({ data }) => {
  const [openTravelGroup, setOpenTravelGroup] = useState(false);
  const [openFromDate, setOpenFromDate] = useState(false);
  const [openToDate, setOpenToDate] = useState(false);
  const openTravelGroupRef = useRef(null);
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery("sm");
  const isMediumScreen = useMediaQuery("md");
  const widgetConfig = {};
  const navigate=useNavigate()
  return (
    <>
    <Box
      className="test"
      sx={{
        backgroundColor: "#F9F5F0",
        p: 1,
        width: isSmallScreen ? "100%" : "80%", // Dynamically adjust width
      }}
    >
      <Grid container spacing={2}>
        {/* Travel Group */}
        <Grid item xs={12} sm={6} md={2}>
          <TravelGroup />
        </Grid>

        {/* Category */}
        <Grid item xs={12} sm={6} md={2}>
          <Category />
        </Grid>

        {/* From Date */}
        <Grid item xs={12} sm={6} md={2}>
          <FromDateComponent />
        </Grid>

        {/* To Date */}
        <Grid item xs={12} sm={6} md={2}>
          <ToDateComponent />
        </Grid>

        {/* Book Now Button */}
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
<Button
  onClick={() => navigate('/HotelWidget')}
  sx={{
    width: "100%",
    maxWidth: 220,
    py: 1.8,
    mt: 1,
    borderRadius: "14px",
    backdropFilter: "blur(10px)",
    background: "orange",
    color: "#000",
    fontWeight: 600,
    fontSize: "1rem",
    textTransform: "none",
    border: "1px solid rgba(255,255,255,0.4)",
    transition: "0.25s ease",
    "&:hover": {
      background: "lightgrey",
      transform: "translateY(-2px)",
    },
    "&:active": {
      transform: "scale(0.97)",
    },
  }}
>
  Book Now
</Button>

        </Grid>
      </Grid>
    </Box>
  </>
  );
};

export default Widget;
